import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { FormTextarea } from '../../../components/form/FormTextarea';
import { Loader } from '../../../components/Loader';

let VehiclesForm = props => {
  const { error, handleSubmit, submitting } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field name="note" type="textarea" label="Замечания" row="4" component={FormTextarea} />

      {error && <strong>{error}</strong>}
      <div>
        {submitting && <Loader />}
        <button name="action" value="decline" className="btn" type="submit" disabled={submitting}>
          Отклонить
        </button>
      </div>
    </form>
  );
};

VehiclesForm = reduxForm({
  form: 'vehicle-admin', // a unique identifier for this form
  enableReinitialize: true
})(VehiclesForm);

VehiclesForm = connect(state => ({
  initialValues: {
    id: state.adminVehicles.currentItem ? state.adminVehicles.currentItem.id : '',
    note: state.adminVehicles.currentItem ? state.adminVehicles.currentItem.note : '',
    status: 1
  }
}))(VehiclesForm);

export default VehiclesForm;
